import requestList from '@/api/corporation';

const state = {
  list: null,
};

const getters = {
  list: (state) => state.list,
};

const actions = {
  // async setList({ commit, dispatch }) {
  async setList({ commit, dispatch }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestList();
    commit('setList', result);
    await dispatch('setIsLoading', false, { root: true });
  },
};

const mutations = {
  setList(state, result) {
    state.list = result.data.list;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
